// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductSummaryPanel_container___we3h","count":"ProductSummaryPanel_count__uy8ai","price":"ProductSummaryPanel_price__oyh2S","link":"ProductSummaryPanel_link__BGOmS"};